module.exports = __webpack_public_path__ + "static/img/bottomIMG.5921b474.jpg";